import { Notification } from "@vds/notifications";
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { GetFooterNotes, GetHelperText, GetPlanPageDetails, GetSelectedDeviceDetails } from "../../shared/components/GetPlanPageDetails.jsx";
import FullPageLoader from '../../shared/components/Loader';
import { getDestList, getDevicesPayload } from '../../shared/utils/globalUtils';
import { dispatchNotifyEvent, dispatchPageView } from '../../shared/utils/tagging';
import { convertStringToElements } from '@vds/html-parsers';
import { TextLink } from "@vds/buttons";
import { unauth, unauthItpNsaFFlag,reloadRedirectFixFFlag } from '../../shared/utils/globalConfig';
import { saveSelectedDeviceDetails,updateSelectedPlanData } from '../../features/selectedData/selectedDataReducer';
import ErrorPage from '../../shared/components/ErrorPage';
import {saveConfirmedPlanData } from '../../features/selectedData/persistantDataReducer';
import xss from 'xss';

const PlanSelectionPageMain = styled.div`
`
const Space = styled.div`
padding-top: ${props => props.pt || 20}px;
`
const StyledTextLink = styled.div`
text-decoration: underline;
`
export default function PlanSelection() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedDestinations, selectedDates,selectedDeviceDetailsUnauth } = useSelector(state => state?.persistantReducer);
    const { selectedDeviceDetails } = useSelector(state => state?.selectedReducer);
    

   


    const getDevicesPayloadUnauth = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payload;
    }
    const Payload = unauth ? getDevicesPayloadUnauth() : getDevicesPayload(selectedDates,selectedDestinations);
    const { data, isSuccess, isLoading, error } = useGetDevicesAndPlansByNameQuery(Payload,
    { skip: unauth && (Object.keys(selectedDeviceDetailsUnauth).length == 0 || selectedDestinations?.length === 0) })
   
    const [planPageDetails, setPlanDetails] = useState();
    const [devicesAndPlans, setDevicesAndPlans] = useState();


    //Redirect to destination, if destination and travel dates are empty
    useEffect(() => {
        if (reloadRedirectFixFFlag && ( selectedDates?.travelStartDate == undefined && selectedDates?.travelEndDate == undefined || selectedDestinations.length === 0 )) {
            if (unauth) {
                window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
            }
            else {
                window.location.href = xss('/digital/nsa/secure/ui/intl/trip/');
            }
        }
    }, [])

    useEffect(() => {
        let selecteddevice = unauth ? selectedDeviceDetailsUnauth : selectedDeviceDetails
        if (Object.keys(selecteddevice).length === 0) {
            navigate(-1, { replace: true })
        }
    }, [unauth ? selectedDeviceDetailsUnauth : selectedDeviceDetails])

    useEffect(() => {
        setPlanDetails(data?.body?.data?.planDetailsLand);
        setDevicesAndPlans(data?.body?.data?.devicesAndPlans)
    }, [data]);

    //saveSelectedDeviceDetails from planpage response for unauth flow 
    //clear the confirmedplandata again if the user starts from landplan through back arrow
    useEffect(() => {
        if(unauth) 
           {
            dispatch(saveSelectedDeviceDetails(data?.body?.data?.devicesAndPlans?.deviceDetails[0])); 
            dispatch(saveConfirmedPlanData([]));
            dispatch(updateSelectedPlanData({}));
        } 
    }, [data]);

    
     

    useEffect(() => {

        if (selectedDeviceDetails?.availableCanMexCovered) {
            dispatchNotifyEvent(planPageDetails?.lineCoverage?.title, '', planPageDetails?.lineCoverage?.subtitle)
        }

    }, [])
    useEffect(() => {
        if (devicesAndPlans?.payGoOnly && devicesAndPlans?.payGoOnlyNotificationText) {
            dispatchNotifyEvent(devicesAndPlans?.payGoOnlyNotificationText, "99")
        }
        if (devicesAndPlans?.mixedPayGo && devicesAndPlans?.mixedPayGoNotificationText) {
            dispatchNotifyEvent(devicesAndPlans?.mixedPayGoNotificationText)
        }
    },[devicesAndPlans])
    //Tagging
    useEffect(() => {
        dispatchPageView('ITP_PlanSelection', 'plan selection','#plan_selection');
    }, [])


    const getLandPlans = () => {
        let plans = [];
        let landplans = planPageDetails?.planInfo.map((plan) => {
            if (plan?.planTypeName === 'TRAVELPASS' && selectedDeviceDetails.travelPassPlan && plan?.planId === selectedDeviceDetails?.availableTravelpassId) {
                let travelPassUpdated = JSON.parse(JSON.stringify(plan))
                travelPassUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsTravelPass;
                plans.push(travelPassUpdated)
            }
            if (plan?.planTypeName === 'MONTHLY' && selectedDeviceDetails.monthlyPlan && selectedDeviceDetails.monthlyITPRecurring) {
                let monthlyUpdated = JSON.parse(JSON.stringify(plan))
                monthlyUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsMonthly;
                plans.push(monthlyUpdated)
            }
            if (plan?.planTypeName === 'MONTHLY_RECURRING' && !selectedDeviceDetails.monthlyPlan && selectedDeviceDetails.monthlyITPRecurring) {
                let monthlyUpdated = JSON.parse(JSON.stringify(plan))
                monthlyUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsMonthlyRecurring;
                plans.push(monthlyUpdated)
            }
            if (plan?.planTypeName === 'PAYGO_LAND' && selectedDeviceDetails.payAsYouGoLand) {
                let paygolandUpdated = JSON.parse(JSON.stringify(plan))
                paygolandUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsPaygoLand;
                plans.push(paygolandUpdated)
            }
        })
        return plans;
    }

    return (
        <PlanSelectionPageMain id="plan_selection">
            {(isSuccess && planPageDetails)
                ?
                <>
                    <GetSelectedDeviceDetails planType='land'/>
                    <Space />
                    <Title size="XLarge">{planPageDetails?.pageTitle}</Title>
                    <Space />
                    <Body size="large">{planPageDetails?.heading}</Body>
                    {planPageDetails?.discountedCustomer && <><Space /><Body size="large">{planPageDetails?.discountedPlans}</Body></>}
                    {selectedDeviceDetails?.availableCanMexCovered && <Notification
                        type="info"
                        title={planPageDetails?.lineCoverage?.title}
                        subtitle={planPageDetails?.lineCoverage?.subTitle}
                        fullBleed={false}
                        inline={false}
                        disableFocus={true}
                        hideCloseButton={true}
                    />}
                    {devicesAndPlans?.payGoOnly && devicesAndPlans?.payGoOnlyNotificationText &&
                        <Notification
                            type="error"
                            title={convertStringToElements(devicesAndPlans?.payGoOnlyNotificationText)}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                            hideCloseButton={true}
                        />}

                    {devicesAndPlans?.mixedPayGo && devicesAndPlans?.mixedPayGoNotificationText &&
                        <Notification
                            type="warning"
                            title={convertStringToElements(devicesAndPlans?.mixedPayGoNotificationText)}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                            hideCloseButton={true}
                         />}
                    {(selectedDeviceDetails?.currentPlanDetails.filter((plan) => plan?.monthlyITP === true).length > 0) &&
                        <> <Space />
                            <Notification
                                type="warning"
                                title={<>{devicesAndPlans?.monthlyCurrentPlanText}
                                &nbsp; <StyledTextLink aria-label="removePlan" onClick={() => { window.location.href = devicesAndPlans?.removePlanUrl }}>{devicesAndPlans?.removePlanText}</StyledTextLink>
                                </>}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                                hideCloseButton={true}
                            /> </>
                    }
                    <GetPlanPageDetails availablePlans={getLandPlans()} theme='monarch' planType={'land'} />
                    <GetHelperText subHeadingText={planPageDetails?.subHeadingText} />
                    <Space pt={32}></Space>
                    <GetFooterNotes footerNotes={planPageDetails?.footerNotes} />
                </>
                :
                (error && <ErrorPage errorDetails={error?.data} />)
            }
                {isLoading && <FullPageLoader />}
               
        </PlanSelectionPageMain>);
} 